export const COOKIES_VERSION = '2025-08-24';
export const PRIVACY_VERSION = '2025-08-29';